import { defineComponent as _defineComponent } from 'vue'
import { computed, toRefs } from "vue";
import {
  criterions,
  getItemsBy,
  alternatives,
  getWeightedAcceptability,
  getRangeColorClass,
  stakeholders,
  getStakeholderName,
  getAlternativeName,
} from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'TableChartThree',
  props: {
  selectedAlternative: {
    type: Number,
  },
},
  setup(__props) {

const props = __props



const { selectedAlternative } = toRefs(props);

const rows = computed(() => {
  return criterions.value.map(({ name, id: criterionId }) => {
    const columns = stakeholders.value.map(({ id: stakeholderId }) => {
      const items = getItemsBy({
        criterion: criterionId,
        stakeholder: stakeholderId,
        alternative: selectedAlternative.value,
      });

      const stakeholderName = getStakeholderName(stakeholderId);

      const acceptability = getWeightedAcceptability([...items])[
        selectedAlternative.value
      ];

      return {
        acceptability,
        alternative: selectedAlternative.value,
        stakeholder: stakeholderId,
        stakeholderName: stakeholderName,
      };
    });

    return { name, criterion: criterionId, columns };
  });
});

return { __sfc: true,props, selectedAlternative, rows, getRangeColorClass, stakeholders, getAlternativeName }
}

})